import * as React from 'react';
const InsuranceCardOptions = options => {
    return options.map(({ name }, index) => index >= options.length - 2 ? (React.createElement(React.Fragment, null,
        React.createElement("span", { key: index, dangerouslySetInnerHTML: { __html: name } }),
        index === options.length - 2 ? `, ` : null)) : (React.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: name } })));
};
export default InsuranceCardOptions;
